import { isValidPhoneNumber } from 'react-phone-number-input';
import z from 'zod';

import { INVALID_CONTACT_MESSAGE } from '@/components/Inputs/contactMessages';

export const guestInvitationSchema = z.object({
  contact: z
    .string()
    .email(INVALID_CONTACT_MESSAGE)
    .or(
      z
        .string()
        .min(1, INVALID_CONTACT_MESSAGE)
        .refine((value) => isValidPhoneNumber(value), {
          message: INVALID_CONTACT_MESSAGE,
        }),
    ),
  name: z.string().min(1, 'Please enter a name.'),
});

export type InviteCrewMember = z.infer<typeof guestInvitationSchema>;
